import React, { useState, useEffect, useReducer } from "react";
import dayjs from "dayjs";
import {
  Box,
  Button,
  Card,
  TableHead,
  TablePagination,
  Skeleton,
  CardContent,
  Container,
  Tooltip,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import NoData from "components/NoData";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import LaunchIcon from "@mui/icons-material/Launch";
import { I18n } from "@aws-amplify/core";
import useMediaQuery from "@mui/material/useMediaQuery";
import currentUserToken from "CurrentUserToken";
import { get } from "aws-amplify/api";

const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    const audit = action.value;
    if (Array.isArray(audit)) {
      audit.forEach((element) => {
        if (typeof element.timestamp === "number") {
          element.timestamp = dayjs(element.timestamp).format(
            "YYYY-MM-DD HH:mm"
          );
        }
      });
      return { audit: audit, fetched: true };
    }
  }
  return lastState;
};

const ActionComponent = ({ selectedRow }) => {
  const navigate = useNavigate();
  return (
    <Tooltip title="View Details">
      <IconButton
        onClick={() => navigate(`/dashboard/alarm-details/${selectedRow.id}`)}
      >
        <LaunchIcon />
      </IconButton>
    </Tooltip>
  );
};
const AssociatedAlarms = ({ data }) => {

  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
  });
  const [alarmsSameDevPage, setAlarmsSameDevPage] = useState(0);
  const [rowsPerAlarmsSameDevPage, setRowsPerAlarmsSameDevPage] = useState(5);
  const formatTimestamp = (timestamp) => dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss");
  const [resourcePrefPage, setResourcePrefPage] = useState(0);
  const [rowsPerResourcePrefPage, setRowsPerResourcePrefPage] = useState(5);

  const tlmGetSalesforceCaseAlarms = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/salesforce/case/alarms",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            sf_case_id: data.id,
          },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Errore durante la chiamata API:", error);
    }
  };

  useEffect(() => {
    if (data?.id) {
      tlmGetSalesforceCaseAlarms();
    }
  }, [data.id]);

  const isMobileDevice = useMediaQuery("(max-width:600px)");

  const headerCells = [
    { id: "datetime_edp_processing", label: I18n.get("Arrival Date"), renderCell: (params) => formatTimestamp(params.value) },
    { id: "source_technology", label: I18n.get("Source Technology") },
    { id: "alarm_text", label: I18n.get("Alarm Text") },
    { id: "original_equipment", label: I18n.get("Original Equipment") },
    {
      id: "action",
      label: I18n.get("Action"),
      renderCell: (params) => <ActionComponent selectedRow={params.row} />, // Use renderCell
    },
  ];

  if (!state.fetched || state.audit.length === 0) {
    return (
      <Card>
        <CardContent sx={{ padding: "1rem", "&:last-child":{padding:"1rem"} }}>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            //sx={{ pb: 2 }}
          >
            <Typography variant="h5">
              {I18n.get("Associated Alarms")}
            </Typography>
          </Stack>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NoData />
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent sx={{ padding: "1rem", "&:last-child":{padding:"1rem"} }}>
        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          //sx={{ pb: 2 }}
        >
          <Typography variant="h5">{I18n.get("Associated Alarms")}</Typography>
        </Stack>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {headerCells.map((column) => (
                  <TableCell key={column.id}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
  {state.audit
    .slice(
      alarmsSameDevPage * rowsPerAlarmsSameDevPage,
      alarmsSameDevPage * rowsPerAlarmsSameDevPage + rowsPerAlarmsSameDevPage
    )
    .map((mappingRow, rowIndex) => (
      <TableRow key={rowIndex}>
        {headerCells.map((column) => (
          <TableCell key={column.id} sx={{padding:"0px"}}>
            {column.renderCell
              ? column.renderCell({
                  value: mappingRow[column.id],
                  row: mappingRow,
                })
              : mappingRow[column.id] || ""}
          </TableCell>
        ))}
      </TableRow>
    ))}
</TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={state.audit.length}
          page={alarmsSameDevPage}
          onPageChange={(event, newPage) => setAlarmsSameDevPage(newPage)}
          rowsPerPage={rowsPerAlarmsSameDevPage}
          onRowsPerPageChange={(event) => {
            setRowsPerAlarmsSameDevPage(parseInt(event.target.value, 10));
            setAlarmsSameDevPage(0);
          }}
          rowsPerPageOptions={[]}
        />
      </CardContent>
    </Card>
  );
};

export default AssociatedAlarms;
